import React from 'react';
import PropTypes from 'prop-types';

import intlShape from '@/shared/utils/intlShape';
import DataCacheService from '@/shared/services/DataCacheService';
import FormattedListValue from '../../shared/components/FormattedListValue';
import FormattedDateTime from '../../shared/components/FormattedDateTime';

import { injectStateService, StateService } from '../../shared/services/StateService';
import messages from './jobMessages';
import JobStatus from './JobStatus';

const JobOverviewRow = ({ item, intl, stateService, entityLabel }) => {
  const user = DataCacheService.getUserName(item.createdBy);

  return (
    <tbody className="hover" onDoubleClick={() => stateService.gotoJob(item.id)}>
      <tr>
        <td>
          <FormattedListValue list="jobType" id={item.jobType} />
        </td>
        <td>
          {item.totalEntries} {entityLabel}
        </td>
        <td>
          <JobStatus status={item.status} intl={intl} />
        </td>
        <td>{user}</td>

        <td>
          <FormattedDateTime value={item.createdAt} />
        </td>

        <td>{item.completedAt && <FormattedDateTime value={item.completedAt} />}</td>
        <td className="text-right">
          <button
            type="button"
            onClick={() => stateService.gotoJob(item.id)}
            className="btn btn-sm btn-default"
            title={intl.formatMessage(messages.OpenDetail)}
          >
            <i className="fa fa-info" />
          </button>
        </td>
      </tr>
    </tbody>
  );
};

JobOverviewRow.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    jobType: PropTypes.number.isRequired,
    createdAt: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
    createdBy: PropTypes.string,
    status: PropTypes.number.isRequired,
    completedAt: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  }).isRequired,
  entityLabel: PropTypes.string.isRequired,
  stateService: PropTypes.instanceOf(StateService).isRequired,
  intl: intlShape.isRequired,
};
export default injectStateService(JobOverviewRow);
